<template>
    <div>
        <label for="product" class="label">{{ __('Produto') }}</label>
        <v-select
            class="alo-select"
            :placeholder="__('Selecione..')"
            label="name"
            :options="products"
            :filterable="false"
            v-model="value.product_id"
            :reduce="(product) => product.id"
            :append-to-body="true"
            @search="runSearchDebounced"
        >
            <template v-slot:option="option">
                <div>
                    <div class="flex items-center space-x-2">
                        <div
                            class="w-4 h-4 rounded-full"
                            :class="{
                                'bg-green-500': option.status == 'active',
                                'bg-red-500': option.status == 'inactive',
                            }"
                        ></div>
                        <div>{{ option.name }}</div>
                    </div>
                    <div class="text-sm ml-5">{{ option.code }}</div>
                </div>
            </template>
        </v-select>

        <label for="product_ticket_reason" class="label">{{ __('Motivos') }}</label>
        <treeselect
            v-model="value.product_ticket_reasons_ids"
            :multiple="true"
            :flat="true"
            :default-expand-level="3"
            :options="productTicketReasons"
        />
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { Treeselect } from '@App/Vendor/VueTreeselect.js'
import { debounce } from '@Shared/Functions'
import VSelect from 'vue-select'

export default {
    components: { Treeselect, VSelect },
    props: ['value', 'values'],
    data() {
        return {
            products: [],
            productTicketReasons: [],
        }
    },
    async mounted() {
        this.searchDebounced = debounce(this.runSearch.bind(this), 500)

        if (this.value.product_id) {
            let { data } = await axios('/crm/products/' + this.value.product_id)
            this.products = [data]

            // We need this to refresh the v-select plugin after fetching product data.
            this.$nextTick(() => {
                let originalValue = this.value.product_id
                Vue.set(this.value, 'product_id', null)
                Vue.set(this.value, 'product_id', parseInt(originalValue))
            })
        }

        var { data } = await axios('/crm/product_ticket_reasons', {
            params: { all: true, nested: true, árvore: true, id_space: this.values.id_space },
        })

        this.productTicketReasons = data.map(this.mapProductTicketReasonTreeselect)

        console.log(this.productTicketReasons)

        if (!this.value.product_id) {
            this.runSearch('', () => {})
        }
    },
    watch: {
        'value.product_id'(value) {
            this.justSelectedProduct = true
            setTimeout(() => {
                this.justSelectedProduct = false
            }, 1000)
        },
    },
    methods: {
        runSearchDebounced(search, loading) {
            this.searchDebounced(search, loading)
        },

        async runSearch(search, loading) {
            if (this.justSelectedProduct && search == '') {
                return
            }

            loading(true)

            let { data } = await axios.get('/crm/products', {
                params: {
                    query: search,
                },
            })

            this.products = data.data

            loading(false)
        },

        mapProductTicketReasonTreeselect(productTicketReason) {
            if (productTicketReason.children && productTicketReason.children.length > 0) {
                return {
                    ...productTicketReason,
                    id: productTicketReason.id.toString(),
                    label: productTicketReason.name,
                    children: productTicketReason.children.map(this.mapProductTicketReasonTreeselect),
                }
            } else {
                return {
                    ...productTicketReason,
                    id: productTicketReason.id.toString(),
                    label: productTicketReason.name,
                    children: undefined,
                }
            }
        },
    },
}
</script>
